import React from "react";
import ReactApexChart from "react-apexcharts";
import { useTranslation } from "react-i18next";

interface VoteData {
    options: {
        [key: string]: number;
    };
    date: string;
}

interface Props {
    votesCountByTime: VoteData[];
}

const formatNewDate = (date: Date) => {
    return new Intl.DateTimeFormat("en-GB", {
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    }).format(date);
};

const VotesOverTimeLineChart: React.FC<Props> = ({ votesCountByTime }) => {
    const { t } = useTranslation();
    const dates = votesCountByTime.map((entry) =>
        formatNewDate(new Date(entry.date))
    );
    const optionNames = Object.keys(votesCountByTime[0].options);

    const seriesData = optionNames.map((option) => ({
        name: option,
        data: votesCountByTime.map((entry) => entry.options[option]),
    }));

    const chartOptions = {
        chart: {
            type: "line" as const,
        },
        xaxis: {
            categories: dates,
        },
        yaxis: {
            title: {
                text: t("components.graphs.votesOverTime.yAxis"),
            },
        },
        legend: {
            show: true,
            position: "bottom" as const,
        },
        colors: ["#D549CD", "#2A4971", "#5DC6FF"],
        title: {
            align: "center" as const,
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
                fontSize: "18px",
                color: "#263238",
            },
        },
    };

    return (
        <div>
            <ReactApexChart
                options={chartOptions}
                series={seriesData}
                type="line"
                height={350}
            />
        </div>
    );
};

export default VotesOverTimeLineChart;
